/**
 * @generated SignedSource<<1913b08cd21f76c3c4b635d32a4b7eca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScheduledSlotCell_respondent$data = {
  readonly id: string;
  readonly scheduledSlots: ReadonlyArray<{
    readonly end: any;
    readonly interviewed: boolean;
    readonly session: {
      readonly name: string;
    } | null;
    readonly start: any;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleModal_respondent">;
  readonly " $fragmentType": "ScheduledSlotCell_respondent";
};
export type ScheduledSlotCell_respondent$key = {
  readonly " $data"?: ScheduledSlotCell_respondent$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduledSlotCell_respondent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScheduledSlotCell_respondent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RespondentScheduledSlotNode",
      "kind": "LinkedField",
      "name": "scheduledSlots",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StudySessionNode",
          "kind": "LinkedField",
          "name": "session",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "interviewed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleModal_respondent"
    }
  ],
  "type": "RespondentNode",
  "abstractKey": null
};

(node as any).hash = "5b3b20a8088374fe948a67d03512b069";

export default node;
